import BookNow from "../buttons/BookNow";

export default function InsideIntro() {
  return (
    <>
      <div id='contact-intro' className='banner-image-text'>
        <h1>Inside the apartment</h1>
        <img
          src="../../images/inside/maidenhead-lounge-bed-wide.jpg"
          alt="Double bed, TV, sofa bed, coffee table. Stairs leading upwards"
          className='full-width-image'
        />
      </div>
      <div className='responsive-text'>
        <h2>Sleeps 2-4 people</h2>
        <p>The ground floor is a large, open-plan room. There's a double bed, and a sofa bed.</p>
        <p>Upstairs is a kitchen, bathroom, and a dining/study area.</p>
      </div>
      <BookNow />
    </>
  );
}